import { useMsal } from '@azure/msal-react';
import {
  useIsMsalAuth,
  useUser,
  useUserDataMap,
  loginRequest,
} from '../..';
import {
  AuthAccountResponseType, useAuthAccountApi,
} from '../../../api';
import { useSessionContext } from '../../session';

export function useAuth() {
  const {
    login, refresh, logout, validate,
  } = useAuthAccountApi();
  const userDataMap = useUserDataMap();
  const { instance, accounts } = useMsal();
  const { user, deleteUser } = useUser();
  const { setSessionExpTime, setIsLoggedOut } = useSessionContext();

  const onAuthResponse = (response: AuthAccountResponseType) => {
    userDataMap(response);
  };

  const isInternalUser = useIsMsalAuth();

  return {
    login: (email?: string, password?: string) => login(email, password)
      .then(onAuthResponse),
    refresh: async () => {
      if (isInternalUser) {
        const tokenRequest = { ...loginRequest, account: accounts[0] };
        return instance.acquireTokenSilent(tokenRequest).then(({ accessToken }) => {
          setSessionExpTime(accessToken);
        });
      }
      return refresh().then(onAuthResponse);
    },
    logout: () => {
      setSessionExpTime('');
      setIsLoggedOut(true);

      if (!user) {
        const logoutRequest = {
          account: accounts[0],
          postLogoutRedirectUri: window.location.href,
        };
        instance.logoutRedirect(logoutRequest);
      } else {
        logout()
          .then(() => {
            deleteUser();
          });
      }
    },
    validate: () => validate(),
  };
}
